<div class="page-content">
  <div class="title-box">
    <span class="title">{{ "CUSTOM_CONFIG" | translate }}</span>
  </div>

  <div class="container">
    <div class="config-box">
      <div nz-row>
        <label nz-col nzSpan="6" class="config-label"
          >{{ "THEME" | translate }}:</label
        >
        <div nz-col nzSpan="16" class="config-theme-box">
          <div class="config-theme" (click)="onChangeTheme('industry')">
            <img
              [src]="
                theme === 'industry'
                  ? 'assets/industrial-select.png'
                  : 'assets/industrial.png'
              "
              alt="industrial"
            />
            <label [class.active]="theme === 'industry'">{{
              "INDUSTRY" | translate
            }}</label>
          </div>
          <div class="config-theme" (click)="onChangeTheme('popular')">
            <img
              [src]="
                theme === 'popular'
                  ? 'assets/popular-select.png'
                  : 'assets/popular.png'
              "
              alt="popular"
            />
            <label [class.active]="theme === 'popular'">{{
              "POPULAR" | translate
            }}</label>
          </div>
          <div class="config-theme" (click)="onChangeTheme('rbcd')">
            <img
              [src]="
                theme === 'rbcd' ? 'assets/rbcd-select.png' : 'assets/rbcd.png'
              "
              alt="popular"
            />
            <label [class.active]="theme === 'rbcd'">{{ "RBCD" }}</label>
          </div>
        </div>
      </div>
      <div nz-row>
        <label nz-col nzSpan="6" class="config-label"
          >{{ "LANGUAGE" | translate }}:</label
        >
        <div nz-col nzSpan="16" class="language-box">
          <nz-radio-group
            [(ngModel)]="language"
            nzButtonStyle="solid"
            (ngModelChange)="onChangeLanguage()"
          >
            <label nz-radio-button nzValue="en">{{
              "ENGLISH" | translate
            }}</label>
            <label nz-radio-button nzValue="zh">{{
              "CHINESE" | translate
            }}</label>
          </nz-radio-group>
        </div>
      </div>
    </div>
  </div>
</div>
